import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.refreshTimer = null
    this.handleStreamRender = this.handleStreamRender.bind(this)
    document.addEventListener('turbo:before-stream-render', this.handleStreamRender)
  }

  disconnect() {
    document.removeEventListener('turbo:before-stream-render', this.handleStreamRender)
    if (this.refreshTimer) window.clearTimeout(this.refreshTimer)
  }

  handleStreamRender(event) {
    const target = event.detail?.newStream?.target
    if (!target?.startsWith('uploaded_document_')) return

    if (this.refreshTimer) window.clearTimeout(this.refreshTimer)
    this.refreshTimer = window.setTimeout(() => this.refreshTabs(), 200)
  }

  async refreshTabs() {
    const response = await fetch(window.location.href, {
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })

    if (!response.ok) return

    const html = await response.text()
    const documentFragment = new DOMParser().parseFromString(html, 'text/html')
    const freshTabs = documentFragment.querySelector('#document_tabs')
    if (freshTabs) this.element.replaceWith(freshTabs)
  }
}
